export const MONITORING_EVENT = {
  extendWithToggled: 'Monitoring Extend With Toggled',
  displayOptionChanged: 'Monitoring Display Option Changed',
  compareToToggled: 'Monitoring Compare To Toggled',
  displayModeChanged: 'Monitoring Display Mode Changed',
  criticalElementToggled: 'Monitoring Critical Element Toggled',
} as const satisfies Record<string, string>;

export type MonitoringEventName =
  (typeof MONITORING_EVENT)[keyof typeof MONITORING_EVENT];

export type MonitoringSelectionAction = 'selected' | 'deselected';

export type MonitoringExpansionAction = 'expanded' | 'collapsed';

export type MonitoringComparison = 'mySchool' | 'cohort' | 'mySchoolVsCohort';

export type MonitoringDisplayModeSection = 'totalFunnel' | 'criticalElements';
